import { signal } from "@preact/signals";

/**
 * Mimic context - information about who is being mimicked.
 */
export type MimicState = {
  memberId: string;
  memberName: string;
  workspaceId: string;
  workspaceName: string;
  startedAt: Date;
} | null;

/**
 * Global mimic state.
 * When set, the admin is viewing the app as another user (read-only mode).
 */
export const mimicState = signal<MimicState>(null);

/**
 * Set the mimic state (called when loading page state or starting mimic).
 */
export function setMimicState(state: MimicState): void {
  mimicState.value = state;
}

/**
 * Clear the mimic state (called when stopping mimic).
 */
export function clearMimicState(): void {
  mimicState.value = null;
}

/**
 * Check if we're currently in mimic mode.
 */
export function isInMimicMode(): boolean {
  return mimicState.value !== null;
}
